import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { BILLING_API_URL } from '@rma/billing-api';
import { appendToRmaBillingApiUrl } from '@rma/common-ui-ng/util';

export function provideRmaBillingTokenProvider(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: BILLING_API_URL,
      useFactory: () => inject(appendToRmaBillingApiUrl)().replace(/\/$/, ''),
    },
  ]);
}
